export default __webpack_public_path__ + "static/media/arrow.0b93b21c.svg";